import React from 'react'

import { TableCell } from '@mui/material'
import { TextCell } from '@abra/elements/table/cells/basics/'

const Row = ({ row, ...props }) => <>
  <TableCell size={'small'}><TextCell value={_.get(row, 'name_translated')} /></TableCell>
  <TableCell size={'small'}><TextCell value={_.get(row, 'description_translated')} /></TableCell>
  <TableCell size={'small'}><TextCell value={_.get(row, 'price')} /></TableCell>
  <TableCell size={'small'}><TextCell value={_.get(row, 'currency')} /></TableCell>
</>

export default React.memo(Row)
